import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { routes } from '../../route-list';

/**
 * Component that handles Auth0 error callbacks and redirects to appropriate pages
 */
export const AuthErrorHandler: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    const isStudierDenied =
      error === 'access_denied' &&
      (errorDescription?.toLowerCase().includes('not allowed to access the website') ||
        errorDescription?.toLowerCase().includes('use the mobile app'));

    if (isStudierDenied) {
      history.replace(routes.STUDIER_RESTRICTED);
      return;
    }

    // Check if this is an email verification error
    if (error === 'access_denied' && errorDescription?.toLowerCase().includes('verify your email')) {
      const cleanPath = routes.EMAIL_VERIFICATION;
      history.replace(cleanPath);
    } else if (error) {
      const cleanPath = location.pathname;
      history.replace(cleanPath);
    }
  }, [location, history]);

  return null;
};
